export const translations = {
  ar: {
    brand: 'ترحال',
    brandTagline: 'سافر لتكتشف العالم. كل ما تحتاجه لرحلتك في مكان واحد',

    nav: {
      hotels: 'الفنادق',
      visas: 'التأشيرات',
      buses: 'الحافلات',
      flights: 'الطيران',
      news: 'الأخبار',
      faq: 'الأسئلة الشائعة',
      login: 'تسجيل الدخول',
      register: 'إنشاء حساب',
      dashboard: 'لوحة التحكم',
      logout: 'تسجيل الخروج',
      myBookings: 'حجوزاتي',
      profile: 'الملف الشخصي'
    },

    auth: {
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      fullName: 'الاسم الكامل',
      phone: 'رقم الهاتف',
      loginTitle: 'تسجيل الدخول',
      registerTitle: 'إنشاء حساب',
      noAccount: 'ليس لديك حساب',
      hasAccount: 'لديك حساب بالفعل',
      loginBtn: 'دخول',
      registerBtn: 'تسجيل',
      errors: {
        required: 'هذا الحقل مطلوب',
        invalidEmail: 'البريد الإلكتروني غير صحيح',
        passwordShort: 'كلمة المرور قصيرة',
        passwordsNotMatch: 'كلمتا المرور غير متطابقتين',
        invalidCredentials: 'بيانات الدخول غير صحيحة',
        unauthorized: 'غير مصرح'
      }
    },

    booking: {
      advancedSearch: 'بحث متقدم',
      roundTrip: 'ذهاب وإياب',
      oneWay: 'ذهاب فقط',
      from: 'من',
      to: 'إلى',
      departureCity: 'مدينة المغادرة',
      arrivalCity: 'مدينة الوصول',
      departure: 'المغادرة',
      return: 'العودة',
      passengers: 'المسافرون',
      luggage: 'الأمتعة',
      search: 'بحث',
      searchHotels: 'بحث الفنادق',
      searchVisas: 'بحث التأشيرات',
      requestBus: 'طلب رحلة حافلة',
      requestFlight: 'طلب رحلة طيران',
      city: 'المدينة',
      country: 'الدولة',
      stars: 'النجوم',
      minPrice: 'أقل سعر',
      maxPrice: 'أعلى سعر',
      tripType: 'نوع الرحلة',
      allCities: 'كل المدن',
      allCountries: 'كل الدول',
      allTypes: 'كل الأنواع',
      adults: 'البالغون',
      children: 'الأطفال',
      infants: 'رضع',
      economy: 'اقتصادي',
      business: 'رجال أعمال',
      firstClass: 'درجة أولى',
      fareGroup: 'فئة السعر',
      soon: 'قريبًا'
    },

    sections: {
      popularDestinations: 'وجهات شائعة',
      popularDestinationsDesc: 'أماكن مختارة بأسعار منافسة',
      visaDestinations: 'وجهات التأشيرات',
      visaDestinationsDesc: 'متطلبات التأشيرات للدول المختلفة',
      whyRehlaty: 'لماذا ترحال',
      whyRehlatyDesc: 'منصة متكاملة لحجوزات السفر',
      hotels: 'الفنادق',
      visaServices: 'خدمات التأشيرات',
      visaTypesAvailable: 'أنواع التأشيرات المتاحة'
    },

    features: {
      instantBooking: 'حجز فوري',
      instantBookingDesc: 'احجز مباشرة بدون انتظار',
      secure: 'آمن',
      secureDesc: 'معاملات مشفرة',
      secureBadge: 'آمن',
      support: 'دعم مستمر',
      supportDesc: 'متاح دائمًا',
      supportBadge: '24 ساعة',
      bestPrice: 'أفضل سعر',
      bestPriceDesc: 'أسعار تنافسية',
      bestPriceBadge: 'أفضل عرض'
    },

    dashboard: {
      title: 'لوحة التحكم',
      welcome: 'مرحبًا',
      overview: 'نظرة عامة',
      users: 'المستخدمون',
      bookings: 'الحجوزات',
      payments: 'المدفوعات',
      accounting: 'المحاسبة',
      chartOfAccounts: 'شجرة الحسابات',
      journalEntries: 'القيود اليومية',
      trialBalance: 'ميزان المراجعة',
      incomeStatement: 'قائمة الدخل',
      balanceSheet: 'الميزانية العمومية',
      reports: 'التقارير',
      visas: 'التأشيرات',
      settings: 'الإعدادات',
      totalRevenue: 'إجمالي الإيرادات',
      totalBookings: 'إجمالي الحجوزات',
      pendingBookings: 'حجوزات معلقة',
      completedBookings: 'حجوزات مكتملة',
      recentBookings: 'آخر الحجوزات',
      addUser: 'إضافة مستخدم',
      addAccount: 'إضافة حساب',
      addEntry: 'إضافة قيد'
    },

    payments: {
      title: 'المدفوعات',
      amount: 'المبلغ',
      method: 'طريقة الدفع',
      status: 'الحالة',
      paid: 'مدفوع',
      unpaid: 'غير مدفوع'
    },

    reports: {
      filters: 'الفلاتر',
      fromDate: 'من تاريخ',
      toDate: 'إلى تاريخ',
      export: 'تصدير'
    },

    status: {
      pending: 'معلق',
      confirmed: 'مؤكد',
      completed: 'مكتمل',
      cancelled: 'ملغى'
    },

    common: {
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      add: 'إضافة',
      view: 'عرض',
      loading: 'جاري التحميل',
      error: 'خطأ',
      success: 'تم بنجاح',
      noData: 'لا توجد بيانات',
      actions: 'إجراءات',
      confirm: 'تأكيد',
      yes: 'نعم',
      no: 'لا',
      searchPlaceholder: 'بحث',
      Country: 'الدولة'
    },

    visa: {
      Country: 'الدولة',
      Arabic_Name: 'الاسم بالعربي',
      English_Name: 'الاسم بالانجليزي',
      Duration: 'المدة',
      Price: 'السعر',
      Actions: 'الإجراءات',
      Visa_Services: 'خدمات التأشيرات',
      Fill_the_form_below_to: 'املأ النموذج أدناه لـ',
      Add_Visa: 'إضافة تأشيرة',
      Edit_Visa: 'تعديل التأشيرة',
      Delete_this_visa: 'هل تريد حذف هذه التأشيرة؟',
      No_visas_found: 'لم يتم العثور على تأشيرات',
      Processing_Time: 'وقت المعالجة',
      Save: 'حفظ',
      create: 'إنشاء',
      id: 'رقم',
      Update: 'تحديث'
    },

    footer: {
      services: 'الخدمات',
      support: 'الدعم',
      contact: 'تواصل معنا',
      aboutDesc: 'حلول سفر متكاملة',
      hotelBooking: 'حجز الفنادق',
      busBooking: 'حجز الحافلات',
      visaServices: 'خدمات التأشيرات',
      flightBooking: 'حجز الطيران',
      faq: 'الأسئلة الشائعة',
      contactUs: 'اتصل بنا',
      terms: 'الشروط',
      privacy: 'الخصوصية',
      rights: 'جميع الحقوق محفوظة'
    }
  },

  en: {
    brand: 'Tarhal',
    brandTagline: 'Travel and discover the world. Everything for your trip in one place',

    nav: {
      hotels: 'Hotels',
      visas: 'Visas',
      buses: 'Buses',
      flights: 'Flights',
      news: 'News',
      faq: 'FAQ',
      login: 'Login',
      register: 'Register',
      dashboard: 'Dashboard',
      logout: 'Logout',
      myBookings: 'My Bookings',
      profile: 'Profile'
    },

    auth: {
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      fullName: 'Full Name',
      phone: 'Phone',
      loginTitle: 'Login',
      registerTitle: 'Create Account',
      noAccount: 'No account',
      hasAccount: 'Already registered',
      loginBtn: 'Login',
      registerBtn: 'Register',
      errors: {
        required: 'Required',
        invalidEmail: 'Invalid email',
        passwordShort: 'Password too short',
        passwordsNotMatch: 'Passwords do not match',
        invalidCredentials: 'Invalid credentials',
        unauthorized: 'Unauthorized'
      }
    },

    booking: {
      advancedSearch: 'Advanced Search',
      roundTrip: 'Round Trip',
      oneWay: 'One Way',
      from: 'From',
      to: 'To',
      departureCity: 'Departure City',
      arrivalCity: 'Arrival City',
      departure: 'Departure',
      return: 'Return',
      passengers: 'Passengers',
      luggage: 'Luggage',
      search: 'Search',
      searchHotels: 'Search Hotels',
      searchVisas: 'Search Visas',
      requestBus: 'Bus Booking Request',
      requestFlight: 'Flight Booking Request',
      city: 'City',
      country: 'Country',
      stars: 'Stars',
      minPrice: 'Min Price',
      maxPrice: 'Max Price',
      tripType: 'Trip Type',
      allCities: 'All Cities',
      allCountries: 'All Countries',
      allTypes: 'All Types',
      adults: 'Adults',
      children: 'Children',
      infants: 'Infants',
      economy: 'Economy',
      business: 'Business',
      firstClass: 'First Class',
      fareGroup: 'Fare Class',
      soon: 'Coming Soon'
    },

    sections: {
      popularDestinations: 'Popular Destinations',
      popularDestinationsDesc: 'Selected places with competitive prices',
      visaDestinations: 'Visa Destinations',
      visaDestinationsDesc: 'Visa requirements for countries',
      whyRehlaty: 'Why Tarhal',
      whyRehlatyDesc: 'Integrated travel booking platform',
      hotels: 'Hotels',
      visaServices: 'Visa Services',
      visaTypesAvailable: 'Available Visa Types'
    },

    features: {
      instantBooking: 'Instant Booking',
      instantBookingDesc: 'Book immediately without waiting',
      secure: 'Secure',
      secureDesc: 'Encrypted transactions',
      secureBadge: 'Secure',
      support: 'Continuous Support',
      supportDesc: 'Always available',
      supportBadge: '24 Hours',
      bestPrice: 'Best Price',
      bestPriceDesc: 'Competitive prices',
      bestPriceBadge: 'Best Offer'
    },

    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      overview: 'Overview',
      users: 'Users',
      bookings: 'Bookings',
      payments: 'Payments',
      accounting: 'Accounting',
      chartOfAccounts: 'Chart of Accounts',
      journalEntries: 'Journal Entries',
      trialBalance: 'Trial Balance',
      incomeStatement: 'Income Statement',
      balanceSheet: 'Balance Sheet',
      reports: 'Reports',
      visas: 'Visas',
      settings: 'Settings',
      totalRevenue: 'Total Revenue',
      totalBookings: 'Total Bookings',
      pendingBookings: 'Pending Bookings',
      completedBookings: 'Completed Bookings',
      recentBookings: 'Recent Bookings',
      addUser: 'Add User',
      addAccount: 'Add Account',
      addEntry: 'Add Entry'
    },

    payments: {
      title: 'Payments',
      amount: 'Amount',
      method: 'Payment Method',
      status: 'Status',
      paid: 'Paid',
      unpaid: 'Unpaid'
    },

    reports: {
      filters: 'Filters',
      fromDate: 'From Date',
      toDate: 'To Date',
      export: 'Export'
    },

    status: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      completed: 'Completed',
      cancelled: 'Cancelled'
    },

    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      view: 'View',
      loading: 'Loading',
      error: 'Error',
      success: 'Success',
      noData: 'No data',
      actions: 'Actions',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      searchPlaceholder: 'Search',
      Country: 'Country'
    },

    visa: {
      Country: 'Country',
      Arabic_Name: 'Arabic Name',
      English_Name: 'English Name',
      Duration: 'Duration',
      Price: 'Price',
      Actions: 'Actions',
      Visa_Services: 'Visa Services',
      Fill_the_form_below_to: 'Fill the form below to',
      Delete_this_visa: 'Delete this visa?',
      Add_Visa: 'Add Visa',
      Edit_Visa: 'Edit Visa',
      No_visas_found: 'No visas found',
      Processing_Time: 'Processing Time',
      Save: 'Save',
      id: 'ID',
      create: 'create',
      Update: 'Update'
    },

    footer: {
      services: 'Services',
      support: 'Support',
      contact: 'Contact Us',
      aboutDesc: 'Integrated travel solutions',
      hotelBooking: 'Hotel Booking',
      busBooking: 'Bus Booking',
      visaServices: 'Visa Services',
      flightBooking: 'Flight Booking',
      faq: 'FAQ',
      contactUs: 'Contact Us',
      terms: 'Terms',
      privacy: 'Privacy',
      rights: 'All rights reserved'
    }
  }
};
